import React from 'react';

import { Alert as AntDAlert } from 'antd';
import type { AlertProps } from 'antd';
import styled from 'styled-components';

type AlertAction = {
  dataTestId: string;
  label: string;
  onClick: () => void;
};

interface Props extends AlertProps {
  actions?: AlertAction[];
  dataTestId?: string;
}

const StyledAlert = styled(AntDAlert)`
  width: fit-content;
  margin-left: 30px;
  padding: 0;
  border-radius: 4px;
  font-size: 14px;
  font-family: var(--font-bold);

  .ant-alert-icon {
    margin: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--white);
    border-radius: 50%;
    border: solid 1px var(--white);
  }

  .ant-alert-icon svg {
    width: 9px;
    height: 9px;
  }
  .ant-alert-message {
    height: 33px;
    display: flex;
    align-items: center;
    padding-left: 10px;
  }

  .ant-alert-description {
    font-size: 13px;
  }

  &.ant-alert-warning {
    background-color: var(--negative-orange);
    border: solid 1px var(--negative-orange);

    .ant-alert-icon svg {
      color: var(--negative-orange);
    }

    .ant-alert-message {
      color: var(--negative-orange);
      background-color: var(--pale-white);
    }
  }
`;

const ActionWrapper = styled.div`
  border-radius: 0 4px 4px 0;
  padding: 0 10px;
  height: 33px;
  display: flex;
  align-items: center;

  &.warning {
    color: var(--negative-orange);
    background-color: var(--pale-white);
  }
`;

const ActionText = styled.div`
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;
`;

const Alert = ({ dataTestId = "banner_text", actions, message, ...props }: Props) => {
  return (
    <StyledAlert
      {...props}
      message={
        <span data-test-id={dataTestId}>
          {message}
        </span>
      }
      action={
        <ActionWrapper className={props.type}>
          {actions && actions.length ? (
            <span>
              {actions.map((action, index) => (
                <ActionText data-test-id={action.dataTestId} key={index} onClick={action.onClick}>
                  {action.label}
                </ActionText>
              ))}
            </span>
          ) : undefined}
        </ActionWrapper>
      }
    />
  );
};

export default Alert;
